export default __webpack_public_path__ + "static/media/6-warranty.ff3f0b91.svg";